import { PagedResponse } from "@/types/PagedResponse";
import { PageRequest } from "@/types/pagination";
import { SinistroDTO, SinistroLista } from "@/types/SinistroDTO";
import { Sort } from "@/types/sort";
import { buildFilter } from "@/utils/filter.util";
import axios, { AxiosPromise } from "axios"; 

export const findSinistros = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<SinistroDTO>> => 
    axios.get(`/api/sinistro`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        }
    });

// Lista da tela de sinistros (resposta enxuta)
export const findLista = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<SinistroLista>> =>
    axios.get(`/api/sinistro/lista`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        },
        paramsSerializer: { indexes: null }
    });

// Só o total de pendentes (painel inicial)
export const contarPendentes = (): AxiosPromise<number> =>
    axios.get(`/api/sinistro/contar`, { params: { search: 'status==PENDENTE' } });

export const autoCompleteAtivo = (search: string): AxiosPromise<PagedResponse<any>> =>
    findSinistros(buildFilter(['nome'])(search),{page: 0, size: 20},{sort: 'nome'});

export const getByCodigo = (codigo: string): AxiosPromise<SinistroDTO> => 
    axios.get(`/api/sinistro/${codigo}`);    

export const getByFicha = (codigo: string): AxiosPromise<SinistroDTO[]> => 
    axios.get(`/api/sinistro/ficha/${codigo}`);    

export const create = (sinistro: SinistroDTO): AxiosPromise<SinistroDTO> => 
    axios.post(`/api/sinistro`, sinistro); 

export const update = (sinistro: SinistroDTO, id: string): AxiosPromise<SinistroDTO> => 
    axios.put(`/api/sinistro/${id}`, sinistro); 

export const remove = (codigo: string): AxiosPromise<void> => 
    axios.delete(`/api/sinistro/${codigo}`);     